import React, { useState } from 'react';

export function AddChannelModal({ onClose, onSelect, existingChannels, availableChannels }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedChannels, setSelectedChannels] = useState([]);

  // First filter out existing channels, then apply search term
  const filteredChannels = availableChannels
    .filter(channel => !existingChannels.includes(channel.id))  // Filter out existing channels
    .filter(channel =>
      channel.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const handleChannelToggle = (channelId) => {
    setSelectedChannels(prev => {
      if (prev.includes(channelId)) {
        return prev.filter(id => id !== channelId);
      }
      return [...prev, channelId];
    });
  };

  const handleSubmit = () => {
    onSelect(selectedChannels);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content add-channel-modal">
        <div className="modal-header">
          <h2>Add Channels</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search channels..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>
        </div>
        
        <div className="channels-container">
          {filteredChannels.length === 0 ? (
            <div className="no-channels-message">
              No channels available to add
            </div>
          ) : (
            filteredChannels.map(channel => (
              <div key={channel.id} className="channel-option">
                <label className="channel-label">
                  <input
                    type="checkbox"
                    checked={selectedChannels.includes(channel.id)}
                    onChange={() => handleChannelToggle(channel.id)}
                  />
                  <span>{channel.name}</span>
                </label>
              </div>
            ))
          )}
        </div>

        <div className="modal-actions">
          <button 
            type="button" 
            className="button-secondary" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className="button-primary"
            onClick={handleSubmit}
            disabled={selectedChannels.length === 0}
          >
            Add Selected Channels
          </button>
        </div>
      </div>
    </div>
  );
} 